// IMPORTS

// external
import { Algodv2 } from "algosdk"

// global
import AlgofiClient from "../../algofiClient"
import AlgofiUser from "../../algofiUser"
import { Network } from "../../globals"

// local
import Staking from "./staking"
import StakingConfig, { rewardsManagerAppId, StakingConfigs } from "./stakingConfig"
import StakingUser from "./stakingUser"

// INTERFACE

export default class StakingClient {
  public algofiClient: AlgofiClient
  public algod: Algodv2
  public network: Network
  public stakingConfigs: StakingConfig[]
  public stakingContracts: { [key: number]: Staking } = {}

  /**
   * Constructor for the staking client.
   * 
   * @param algofiClient - algofi client
   */
  constructor(algofiClient: AlgofiClient) {
    this.algofiClient = algofiClient
    this.algod = this.algofiClient.algod
    this.network = this.algofiClient.network
    this.stakingConfigs = StakingConfigs[this.network]
  }

  /**
   * Function to load in all of the global states from the staking contracts and
   * store their state in the object.
   */
  async loadState() {
    await Promise.all(
      this.stakingConfigs.map(async config => {
        if (!(config.appId in this.stakingContracts)) {
           this.stakingContracts[config.appId] = new Staking(this.algod, this, rewardsManagerAppId[this.network], config)
        }
        await this.stakingContracts[config.appId].loadState()
      })
    )
  }

  /**
   * Returns a staking user
   * 
   * @param address - the address of the person we are generating the staking
   * user for
   * @returns a new staking user
   */
  getUser(address: string): StakingUser {
    return new StakingUser(this, address)
  }
    
  async getUpdateUserTxns(user: AlgofiUser): Promise<any> {
    const txns = []

    for (const [stakingAppId, userStakingState] of Object.entries(user.staking.v2.userStakingStates)) {
      if (userStakingState.totalStaked > 0) {
        txns.push(await this.stakingContracts[stakingAppId].getUpdateTargetUserTxn(user))
      }
    }

    return txns
  }
}
